import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { CerebroText, CerebroTextButton } from '../../shared/components';
import { setCookie } from '../utils/cookie';

export interface ICerebroPopupProps {
	open: boolean;
	close: () => void;
	roomUserGuid?: string | undefined;
}

export const CerebroPopup: React.FC<ICerebroPopupProps> = ({ roomUserGuid, open, close }) => {
	const snackbar = useSnackbar();

	const onAcceptTutorial = () => acceptTutorialMutation.mutate();
	const acceptTutorialMutation = useMutation(
		async () => {
			var expDate = new Date();
			expDate.setMonth(expDate.getMonth() + 1);
			expDate.setDate(expDate.getDate() + 30);
			setCookie('LenderPopupCookie', roomUserGuid, expDate);
		},
		{
			onSuccess: () => {
				snackbar.enqueueSnackbar('Tutorial Completed.', { variant: 'success' });
				close();
			},
		}
	);

	return (
		<>
			<Dialog open={open} onClose={close} maxWidth={'lg'}>
				<DialogTitle>Cerebro Capital Launches New Dataroom Experience</DialogTitle>
				<DialogContent>
					<CerebroText sx={{ marginTop: 3, marginBottom: 2 }}>
						Cerebro Capital has launched a new dataroom experience for accessing and managing your deal
						opportunities. You will be redirected to the new dataroom after closing this window.
					</CerebroText>
					<CerebroText>See the screenshot below for an overview of the updated dataroom.</CerebroText>

					<img src={`${process.env.PUBLIC_URL}/DataroomPopup.png`} width="1000"></img>

					<CerebroText sx={{ marginTop: 3 }}>
						If you have any questions, please contact your Cerebro transaction manager.
					</CerebroText>
				</DialogContent>
				<DialogActions>
					{!roomUserGuid && <CerebroTextButton onClick={close}>Close</CerebroTextButton>}
					{roomUserGuid && <CerebroTextButton onClick={onAcceptTutorial}>Continue</CerebroTextButton>}
				</DialogActions>
			</Dialog>
		</>
	);
};
